import { c, s } from '../val.config';

const navigationItemSchema = s.union(
  'type',
  s.object({ type: s.literal('link'), title: s.string(), url: s.route() })
);

export const schema = s.object({
  navigationItems: s.array(navigationItemSchema),
  contactItem: navigationItemSchema,
});

export default c.define('/settings/header.val.ts', schema, {
  navigationItems: [
    { type: 'link', url: '/arbeider', title: 'Arbeider' },
    { type: 'link', url: '/tjenester', title: 'Tjenester' },
    { type: 'link', url: '/om-oss', title: 'Om oss' },
    { type: 'link', url: '/menneskene', title: 'Folkene' },
    { type: 'link', url: '/jobb', title: 'Jobb i Blank' },
    { type: 'link', url: '/handboka', title: 'Håndboka' },
  ],
  contactItem: { type: 'link', url: '/prosjektprat', title: 'Kontakt' },
});
